/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateUserAccessResponseDto interface.
 */
export function instanceOfUpdateUserAccessResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('authId' in value) || value['authId'] === undefined)
        return false;
    if (!('enabled' in value) || value['enabled'] === undefined)
        return false;
    if (!('pin' in value) || value['pin'] === undefined)
        return false;
    return true;
}
export function UpdateUserAccessResponseDtoFromJSON(json) {
    return UpdateUserAccessResponseDtoFromJSONTyped(json, false);
}
export function UpdateUserAccessResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'authId': json['authId'],
        'enabled': json['enabled'],
        'pin': json['pin'],
    };
}
export function UpdateUserAccessResponseDtoToJSON(json) {
    return UpdateUserAccessResponseDtoToJSONTyped(json, false);
}
export function UpdateUserAccessResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'authId': value['authId'],
        'enabled': value['enabled'],
        'pin': value['pin'],
    };
}
//# sourceMappingURL=UpdateUserAccessResponseDto.js.map